import _find from 'lodash/find';

export const processSuggestions = (suggestions) => {

    const players = suggestions['players'].map(suggestion => {

        return mapPlayerInfo(suggestion);

    });

    const teams = suggestions['teams'].map(suggestion => {

        return mapTeamInfo(suggestion);

    });

    return [...teams, ...players].slice(0,12);

};

export const mapPlayerInfo = (playerInfo, imageUrl) => {

    const {
        displayName: fullName,
        playerId: _id,
        teamId,
        active,
        teamTriCode: teamAbbreviation,
        headshots
     } = playerInfo;
    const id = parseInt(_id, 10);
    
    return {
        type: 'p',
        id,
        name: fullName,
        teamId,
        isActivePlayer: active,
        teamAbbreviation,
        image: headshots[0].url,
        tagUrl: {
            pathname: '/search',
            search: `?query=${encodeURIComponent(fullName)}&tag=playerid-${id}`,
        },
        imageFallback: `https://content.mlb.com/images/headshots/current/60x60/generic.png`,
    };

};

export const mapTeamInfo = (teamInfo) => {

    const {
        teamId: _id,
        name,
        displayName,
        logos
    } = teamInfo;
    const id = parseInt(_id, 10);
    const image = _find(logos, { type: "ON_DARK" }).url;
    return {
        type: 't',
        id,
        name,
        displayName,
        image,
        tagUrl: {
            pathname: '/search',
            search: `?query=${encodeURIComponent(name)}&tag=teamid-${id}`,
        },
    };

};
